// Router Setup with PrivateRoutes and Nested Routes

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth/msalConfig";
import { Provider } from "react-redux";
import ErrorPage from "./errors/ErrorPage";
import { store } from "./redux/store";
import PrivateRoutes from "./routes/PrivateRoutes";
import { AdminView } from "./components/Admin/AdminView/AdminView";
import { AdminViewConsolidate } from "./components/Admin/AdminViewConsolidate";
import { EndUserView } from "./components/EndUser/EndUserView";
import { EndUserInputView } from "./components/PlannerInputView/EndUserInputView";
import { EndUserApprovedView } from "./components/PlannerApproveView/EndUserApprovedView";
import { ApproverView } from "./components/Approver/ApproverView";
import { AuthRedirect } from "./auth/authRedirect";
import { AdminDataErrorView } from "./components/Admin/AdminDataErrorView/AdminDataErrorView";
import AdminSupportTicketSummary from "./components/Admin/supportTicketSummary/AdminSupportTicketSummary";
import ApproverHistory from "./components/Admin/approverHistory/ApproverHistory";
import MaintenancePage from "./components/Maintenance/Maintenance";
import SSAControl from "./components/Admin/SSAControl/SSAControl";

async function init() {
  const msalInstance = new PublicClientApplication(msalConfig);
  try {
    if (msalInstance.initialize) await msalInstance.initialize();
  } catch (e) {
    console.warn("MSAL initialize failed or not required", e);
  }

  const router = createBrowserRouter([
    
{
    path: "/maintenance",
    element: <MaintenancePage />
  },

    {
      path: "/",
      element: (
        <Provider store={ store }>
          <AuthRedirect>
            <App />
          </AuthRedirect>
        </Provider>
      ),
      errorElement: <ErrorPage />,
      children: [
        { index: true, element: <Navigate to="/endUserView/input" replace /> },
        {
          path: "/admin",
          element: <PrivateRoutes />, // PrivateRoute wrapper
          children: [
            { index: true, element: <Navigate to="ssa-dashboard" replace /> },
            { path: "ssa-dashboard", element: <AdminViewConsolidate /> },
            { path: "adminView", element: <AdminView /> },
            {path:'approver-history', element: <ApproverHistory />},
            { path: "data-error", element: <AdminDataErrorView /> },
            {path:'support-ticket-summary', element: <AdminSupportTicketSummary />},
            { path: "ssa-control", element: <SSAControl /> },
          ],
        },
        {
          path: "/endUserView",
          element: <PrivateRoutes />,
          children: [
            {
              element: <EndUserView />,
              children: [
                { index: true, element: <Navigate to="input" replace /> },
                { path: "input", element: <EndUserInputView /> },
                { path: "outputView", element: <EndUserApprovedView /> },
              ],
            },
            // { path: "data-error", element: <EndUserDataErrorView /> },
          ],
        },
        {
          path: "/approverView",
          element: <PrivateRoutes />,
          children: [{ index: true, element: <ApproverView /> }],
        },
        // Fallback: Redirect to /admin if nothing matches
        { path: "*", element: <Navigate to="/admin" replace /> },
      ],
    },
  ]);

  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
  root.render(
    <MsalProvider instance={ msalInstance }>
      <RouterProvider router={ router } />
    </MsalProvider>
  );

  reportWebVitals();
}

init();
